export default __webpack_public_path__ + "static/media/cabourg6.0bcd1a7b.jpg";